import React, { useState } from 'react';
import styled from 'styled-components';
import { Title } from '../Components/Ui/Title';
import { MainLayout, InnerLayout } from '../styles/Layouts';
import { Modal } from '../Components/Blog/Modal';
import { blogData } from '../data/blogs';

export const Blog = () => {
  const [activeModal, setActiveModal] = useState(null);

  const openModal = id => setActiveModal(id);
  const closeModal = () => setActiveModal(null);

  return (
    <MainLayout>
      <BlogsStyled>
        <Title title={'Blog'} span={'Blog'} />
        <InnerLayout className={'blog'}>
          {blogData.map(blog => (
            <div
              key={blog.id}
              className={'blog-item'}
              onClick={() => openModal(blog.id)}
            >
              <div className='image'>
                <img src={blog.image} alt={blog.alt} />
              </div>
            </div>
          ))}
        </InnerLayout>
        <Modal isActive={activeModal !== null} toggle={closeModal}>
          {activeModal &&
            blogData.find(blog => blog.id === activeModal)?.content}
        </Modal>
      </BlogsStyled>
    </MainLayout>
  );
};

const BlogsStyled = styled.div`
  .blog {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 3rem;
    grid-row-gap: 3rem;
    @media screen and (max-width: 770px) {
      grid-template-columns: repeat(1, 1fr);
    }
    .blog-item {
      background-color: var(--background);
      padding: 0.5rem;
      cursor: pointer;
      transition: all 0.2s ease-in-out;
      &:hover {
        cursor: pointer;
        transform: scale(1.05);
        border: 4px solid var(--primary-color);
      }
      border: 4px solid var(--border-color);
    }
    .image {
      width: 100%;
      height: 100%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .title {
      p {
        font-size: 1.6rem;
        padding: 2rem 0;
        color: var(--title-portfolio-color);
        cursor: pointer;
        transition: all 0.4s ease-in-out;
        &:hover {
          color: var(--title-portfolio-hover-color);
        }
      }
    }
  }
`;
